import Petition from './components/Petition'
import Share from './components/Share'
import T from './components/T'

import apConfig from "@config/323.json"
if (apConfig.actionpage && apConfig.template && apConfig.template == true) { apConfig.actionpage = null; }
export const config = apConfig
export const steps = {Petition,Share}

export const portals = {T}

